// UserFormModal.jsx
import React, { useMemo, useState } from 'react';
import Select from 'react-select';
import api from '../../services/api';
import styles from './UserFormModal.module.scss';

const USERS_API_BASE = process.env.REACT_APP_SUPPORT_API_URL || '';

const roleOptions = [
    { value: 'ROLE_SUPER_ADMIN', label: 'Супер Администратор' },
    { value: 'ROLE_ADMIN', label: 'Администратор' },
    { value: 'ROLE_MANAGER', label: 'Менеджер' },
    { value: 'ROLE_OBSERVER', label: 'Наблюдатель' },
    { value: 'ROLE_YK', label: 'Сотрудник УК' },
    { value: 'ROLE_SPECIALIST', label: 'Специалист' },
    { value: 'ROLE_SPECIALIST_TS', label: 'Специалист технической поддержки' },
    { value: 'ROLE_OKK', label: 'ОКК' },
    { value: 'ROLE_PARTNER', label: 'Партнер' },
    { value: 'ROLE_MASTER', label: 'Мастер' },
    { value: 'ROLE_EXTERNAL', label: 'Внешний пользователь' },
];

const normalizePhone = (v) => String(v || '').replace(/[^\d+]/g, '');

const UserFormModal = ({ user, onSave, onClose }) => {
    const [formData, setFormData] = useState({
        name: user ? user.name : '',
        phone: user ? user.phone : '',
        // в UI оставляем 1 роль, на бэк отправляем массив
        role: user && Array.isArray(user.roles) && user.roles.length ? user.roles[0] : '',
    });

    const selectedRole = useMemo(
        () => roleOptions.find((o) => o.value === formData.role) || null,
        [formData.role]
    );

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            name: formData.name,
            phone: normalizePhone(formData.phone),
            roles: formData.role ? [formData.role] : [],
        };

        try {
            if (user) {
                await api.put(`${USERS_API_BASE}/user/${user.id}`, payload);
            } else {
                await api.post(`${USERS_API_BASE}/user`, payload);
            }
            onSave();
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Ошибка при сохранении пользователя:', error);
        }
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <h2>{user ? 'Редактировать пользователя' : 'Добавить пользователя'}</h2>

                <form onSubmit={handleSubmit}>
                    <label className={styles.label}>Имя</label>
                    <input
                        type="text"
                        name="name"
                        placeholder="Имя"
                        value={formData.name}
                        onChange={(e) => setFormData((p) => ({ ...p, name: e.target.value }))}
                        required
                    />

                    <label className={styles.label}>Телефон</label>
                    <input
                        type="tel"
                        name="phone"
                        placeholder="+7..."
                        value={formData.phone}
                        onChange={(e) => setFormData((p) => ({ ...p, phone: e.target.value }))}
                        required
                    />

                    <label className={styles.label}>Роль</label>
                    <Select
                        options={roleOptions}
                        value={selectedRole}
                        onChange={(opt) => setFormData((p) => ({ ...p, role: opt?.value || '' }))}
                        isSearchable
                        placeholder="Выберите роль"
                        classNamePrefix="react-select"
                    />

                    <div className={styles.buttons}>
                        <button type="submit">Сохранить</button>
                        <button type="button" onClick={onClose}>
                            Отмена
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UserFormModal;
